import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { api } from "../../api";

export function useThreadList(workspaceId: string) {
  const queryKey = useMemo(
    () => ["workspace", workspaceId, "thread"],
    [workspaceId]
  );

  return useQuery({
    queryKey: queryKey,
    queryFn: async () => (await api.listThreads(workspaceId)) || [],
    initialData: [],
  });
}
